import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectAuthUser = createSelector(
  selectAuthState,
  (state: AuthState) => state.user
);

// 🔹 Exportamos para guard y tabs
export const isLoggedIn = createSelector(
  selectAuthState,
  (state: AuthState) => !!state.user
);

export const selectUserWithAvatarUrl = createSelector(
  selectAuthUser,
  (user) =>
    user
      ? { ...user, photoURL: user.photoURL || 'assets/default-avatar.png' }
      : null
);
